import React, { useState } from "react";
import { Button, Collapse, Row, Table } from "antd";
import { PlusCircleFilled } from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import {
  MENU_ADMIN_OBJECT_CHAR_TYPE,
  MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE,
} from "../../../../lib/const/permissions";
import { hasAccess } from "../../../../components/RolesModule/hasAccess";
import { useAppSelector } from "../../../..";
import { getDictionaryItemById } from "../../../../lib/utils";

const columnsWidths = {
  objectTypeName: "200px",
  objectCharTypeName: "200px",
  objectCharTypeAlias: "200px",
};

export const TypesCharacteristicsObjects = ({ charTypeId }: { charTypeId?: number }) => {
  const history = useHistory();

  const { typesCharacteristicsObjects, typesCharacteristicsObjectTypesDic } = useAppSelector(
    (state) => state.typesCharacteristics
  );

  const [activeCollapseKey, setActiveCollapseKey] = useState<string | undefined>();

  const onChangeCollapse = (key: string | string[]) => {
    if (typeof key === "string") {
      setActiveCollapseKey(key);
    } else {
      setActiveCollapseKey(key[0]);
    }
  };

  const onClickPlus = () => {
    history.push(`/types-characteristics-object/create/${charTypeId}`);
  };

  const tableData = typesCharacteristicsObjects?.map((object) => {
    return {
      ...object,
      key: `key_${object.id}`,
      objectTypeName: object || "",
      objectCharTypeName: object.name || "",
      objectCharTypeAlias: object?.alias,
    };
  });

  const columns = [
    {
      title: "Объект",
      dataIndex: "objectTypeName",
      key: "objectTypeName",
      width: columnsWidths.objectTypeName,
      render: (value, record) => {
        return getDictionaryItemById(typesCharacteristicsObjectTypesDic, record?.objectTypeId)
          ?.name;
      },
    },
    {
      title: "Наименование",
      dataIndex: "objectCharTypeName",
      key: "objectCharTypeName",
      width: columnsWidths.objectCharTypeName,
      render: (value, record) => {
        if (hasAccess(MENU_ADMIN_OBJECT_CHAR_TYPE, MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE)) {
          return (
            <Link to={`/types-characteristics-object/${record?.objectTypeId}/${record?.id}`}>
              {value}
            </Link>
          );
        }

        return value;
      },
    },
    {
      title: "Alias",
      dataIndex: "objectCharTypeAlias",
      key: "objectCharTypeAlias",
      width: columnsWidths.objectCharTypeAlias,
    },
  ];

  return (
    <Collapse
      bordered={false}
      activeKey={activeCollapseKey}
      onChange={onChangeCollapse}
      className="types-characteristics-params-container__collapse"
    >
      <Collapse.Panel
        key="1"
        header={
          <Row
            style={{ width: "100%" }}
            justify="space-between"
            className="types-characteristics-create-container__pageTitle"
          >
            <Row style={{ width: "100%" }}>
              <h3 style={{ margin: 0 }}>Объекты</h3>
              <Row justify="space-between">
                <div />
                {hasAccess(MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE) && (
                  <Button
                    style={{
                      color: "#00BB77",
                      marginLeft: "5px",
                      marginTop: "-2px",
                      border: "none",
                      background: "transparent",
                    }}
                    shape="circle"
                    className="button-icon"
                    icon={
                      <PlusCircleFilled
                        onClick={(e) => {
                          e.stopPropagation();
                          onClickPlus();
                        }}
                      />
                    }
                  />
                )}
              </Row>
            </Row>
          </Row>
        }
      >
        <Table columns={columns} dataSource={tableData} pagination={false} />
      </Collapse.Panel>
    </Collapse>
  );
};
